<template>
  <div class="app">
    <splitpanes class="default-theme">
      <pane size="10">
        <bd-aside></bd-aside>
      </pane>
      <pane>
        <bd-main></bd-main>
      </pane>
    </splitpanes>
  </div>
</template>

<script>
// https://antoniandre.github.io/splitpanes/
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
// import { Layout } from 'vue-split-layout'
import BdAside from '@/components/dashboard/main/robot/BdAside'
import BdMain from '@/components/dashboard/main/robot/BdMain'

export default {
  name: 'bd-online',
  components: {
    BdAside,
    BdMain,
    Splitpanes, Pane
  },
  data() {
    return {
      resize: true,
    }
  }
}
</script>

<style scope>
</style>
